import React, { memo } from 'react';
import styled from 'styled-components';

import { SIZES, TYPES, SIZE_CONFIG, LINK_COLOR } from '@front/common/src/constants/link';
import { LinkSize, LinkType } from '@front/common/src/types/components';

import Text, { TextProps } from '../base-text/base-text';

import { linkStyle } from './common';

const StyledLink = styled.a<{ $color: string }>`
  ${({ $color }) => linkStyle($color)}
`;

export type SimpleLinkProps = Pick<TextProps, 'children'> & {
  title?: string;
  href?: string;
  openInNewTab?: boolean;
  className?: string;
  type?: LinkType;
  size?: LinkSize;
};

const SimpleLink = ({
  children,
  title,
  href,
  openInNewTab = false,
  className,
  type = 'normal',
  size = 'md',
}: SimpleLinkProps) => {
  const color = LINK_COLOR[type];
  return (
    <StyledLink
      className={className}
      $color={color}
      href={href}
      title={title}
      target={openInNewTab ? '_blank' : undefined}
      rel={openInNewTab ? 'noopener' : undefined}
    >
      <Text fontWeight={500} color={color} {...SIZE_CONFIG[size]}>
        {children}
      </Text>
    </StyledLink>
  );
};

// Delete this export when migration into typescript will be finished
export { SIZES, TYPES };
export default memo(SimpleLink);
